import { Link, useLocation } from "react-router-dom";

const ScheduleNav = () => {
  const location = useLocation();
  
  const days = [
    { label: "Day 1", path: "/day-1" },
    { label: "Day 2", path: "/day-2" },
    { label: "Day 3", path: "/day-3" },
    { label: "VIP Day 4", path: "/vip-day-4", isVIP: true },
  ];

  return (
    <div className="bg-white border-b border-gray-100 sticky top-16 z-40">
      <div className="container mx-auto px-4">
        <div className="flex justify-center py-4">
          <div className="inline-flex bg-gray-100 rounded-xl p-1.5">
            {days.map((day) => {
              const isActive = location.pathname === day.path;
              return (
                <Link
                  key={day.path}
                  to={day.path}
                  className={`px-5 py-2.5 rounded-lg font-semibold text-sm transition-all ${
                    isActive
                      ? day.isVIP
                        ? "bg-gradient-to-r from-[#d8239b] to-[#ff69b4] text-white shadow-md"
                        : "bg-white text-[#2e4053] shadow-md"
                      : day.isVIP
                        ? "text-[#d8239b] hover:bg-white/50"
                        : "text-[#2e4053]/70 hover:bg-white/50"
                  }`}
                >
                  {day.label}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleNav;
